import script from "./LocaleSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocaleSelector.vue?vue&type=script&lang=ts&setup=true"

import "./LocaleSelector.vue?vue&type=style&index=0&id=7bb39e49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb39e49"]])

export default __exports__